import { render } from "./TheTitle.vue?vue&type=template&id=b0968f28"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__